import React from 'react';
import { Formik, Form, Field } from 'formik';

const AppointmentForm = ({ index }) => {
    const loadOptions = [
        {
            label: 'Default Script', value: `Dear <blank>

Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.` },
        {
            label: 'Script 1', value: `Hey Sumeet-

My name is Richard, I am a lead appraising agent for cardropsouthflorida.com.. I didnt want to call you as its kinda late, quick question- would it be possible to snap me a picture of your vin number and send over? I want to provide the most accurate and aggressive price and the VIN really helps. Looking forward to working with you.

Richard
7176341774` },
        {
            label: 'Script 2', value: `Hey Sumeet-

My name is Richard, I am a lead appraising agent for cardropsouthflorida.com.. I didnt want to call you as its kinda late, quick question- would it be possible to snap me a picture of your vin number and send over? I want to provide the most accurate and aggressive price and the VIN really helps. Looking forward to working with you.

Richard
7176341774` }
    ];
    return (
        <>
            <Formik
                initialValues={{
                    loadScript: loadOptions[0]?.label || '',
                    frequency: '',
                    scriptPreview: loadOptions[0]?.value || '',
                    sms_text: false,
                    email: false
                }}
                onSubmit={(values) => {
                    console.log('Form Submitted:', values);
                }}
            >
                {({ values, setFieldValue }) => (
                    <Form className='custom-form appointment-form row'>
                        <div className='col-md-6 mb-3'>
                            <label htmlFor="loadScript">Load Script</label><br />
                            <Field
                                as="select"
                                name="loadScript"
                                className="form-control"
                                onChange={(e) => {
                                    const selectedValue = e.target.value;
                                    setFieldValue('loadScript', selectedValue);
                                    const selectedOption = loadOptions.find(
                                        (option) => option.label === selectedValue
                                    );
                                    setFieldValue('textAreaField', selectedOption?.value || '');
                                }}
                            >
                                {loadOptions.map((option) => (
                                    <option key={option.label} value={option.label}>
                                        {option.label}
                                    </option>
                                ))}
                            </Field>
                        </div>
                        <div className='col-md-6 mb-3'>
                            <label htmlFor="frequency">Frequency</label><br />
                            <Field
                                as="select"
                                name="frequency"
                                className="form-control"
                            >
                                <option value="" label="24hr before appointment" />
                            </Field>
                        </div>
                        <div className='col-md-6'>
                            <label htmlFor="scriptPreview">Script Preview</label><br />
                            <Field as="textarea" name="scriptPreview" className="form-control" />
                        </div>
                        <div className='col-md-6'>
                            <label>&nbsp;</label><br />
                            <label className="custom-checkbox cc-gray-btn cc-black-btn me-3">
                                <Field
                                    type="checkbox"
                                    id={`sms_text-${index}`}
                                    name={`sms_text-${index}`}
                                />
                                <label htmlFor={`sms_text-${index}`}>SMS Text</label>
                            </label>
                            <label className="custom-checkbox cc-gray-btn cc-black-btn">
                                <Field
                                    type="checkbox"
                                    id={`email-${index}`}
                                    name={`email-${index}`}
                                />
                                <label htmlFor={`email-${index}`}>Email</label>
                            </label>
                        </div>
                    </Form>
                )}
            </Formik>
        </>
    )
}

export default AppointmentForm